(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"));else if (typeof define === 'function' && define.amd) define("react-hook-thunk-reducer", ["React"], factory);else if (typeof exports === 'object') exports["react-hook-thunk-reducer"] = factory(require("react"));else root["react-hook-thunk-reducer"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function (__WEBPACK_EXTERNAL_MODULE_react__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "/dist/";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/thunk-reducer.js");
      /******/
    }
    /************************************************************************/

    /******/
    ({
      /***/
      "./src/thunk-reducer.js":
      /*!******************************!*\
        !*** ./src/thunk-reducer.js ***!
        \******************************/

      /*! exports provided: useThunkReducer, default */

      /***/
      function srcThunkReducerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "useThunkReducer", function () {
          return useThunkReducer;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

        function _slicedToArray(arr, i) {
          return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
        }

        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }

        function _iterableToArrayLimit(arr, i) {
          if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
            return;
          }

          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }
        /**
         * @function Thunk
         * @param {Dispatch} dispatch
         * @param {Function} getState
         * @returns {void|*}
         */

        /**
         * @function Dispatch
         * @param {Object|Thunk} action
         * @returns {void|*}
         */

        /**
         * Augments React's useReducer() hook so that the action
         * dispatcher supports thunks.
         *
         * @param {Function} reducer
         * @param {*} initialArg
         * @param {Function} [init]
         * @returns {[*, Dispatch]}
         */


        function useThunkReducer(reducer, initialArg) {
          var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a) {
            return a;
          };

          var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(init(initialArg)),
              _useState2 = _slicedToArray(_useState, 2),
              hookState = _useState2[0],
              setHookState = _useState2[1]; // State management.


          var state = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(hookState);
          var getState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
            return state.current;
          }, [state]);
          var setState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (newState) {
            state.current = newState;
            setHookState(newState);
          }, [state, setHookState]); // Reducer.

          var reduce = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (action) {
            return reducer(getState(), action);
          }, [reducer, getState]); // Augmented dispatcher.

          var dispatch = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (action) {
            return typeof action === 'function' ? action(dispatch, getState) : setState(reduce(action));
          }, [getState, setState, reduce]);
          return [hookState, dispatch];
        }
        /* harmony default export */


        __webpack_exports__["default"] = useThunkReducer;
        /***/
      },

      /***/
      "react":
      /*!**************************************************************************************!*\
        !*** external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"} ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function react(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/
      }
      /******/

    })
  );
});